// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2C4I-","choiceBoxes":"toolbarselects_choiceBoxes__rYCki","simpleField":"toolbarselects_simpleField__JqkbW"};